export const createProjectStyle = (image: string) => {
    return {
        backgroundImage: `url(${image})`,
        backgroundSize: 'cover',
    }
}